export const ArrowFIcon = () => {
    return (
        <svg
            width="19"
            height="9"
            viewBox="0 0 19 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.5 0.5L18.5 4.5M18.5 4.5L14.5 8.5M18.5 4.5L0.5 4.5"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
